<template>
    <div>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <h4 class="kt-panel-title">
                        {{ $t('label.wallet_settlement_blacklist.forbidden_sheba_title') }}
                    </h4>
                </kt-panel-header-toolbar>
                <div class="clearfix mt-2">
                    <button 
                        class="btn btn-success float-left"
                        @click="openAddModal"
                    >
                        <i class="fa fa-plus"></i>
                        {{ $t('label.wallet_settlement_blacklist.forbidden_keywords_add_sheba') }}
                    </button>
                </div>
            </kt-panel-header>
            <kt-panel-body>
                <forbidden-keyword-filter :action="filterAction"></forbidden-keyword-filter>
                <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
            </kt-panel-body>
        </kt-panel>

        <div class="modal fade" id="forbiddenKeywordModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ isEditMode ? $t('label.wallet_settlement_blacklist.edit_sheba') : $t('label.wallet_settlement_blacklist.forbidden_keywords_add_sheba') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal">
                            <span>&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="saveKeyword" id="forbiddenKeywordForm">
                        <div class="modal-body">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label for="forbiddenKeyword">
                                        {{ $t('label.wallet_settlement_blacklist.forbidden_keywords_add_sheba') }} *
                                    </kt-form-label>
                                    <div class="input-group ltr-input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">IR</span>
                                        </div>
                                        <kt-form-control
                                            ref="name"
                                            name="name"
                                            id="forbiddenName"
                                            v-model="numberOnly"
                                            :placeholder="$t('label.wallet_settlement_blacklist.forbidden_sheba_placeholder')"
                                            type="text"
                                            dir="ltr"
                                            @keypress="onlyNumbers"
                                            required
                                        />
                                    </div>
                                    <small class="text-info" v-if="bankNickname">{{ bankNickname }}</small>
                                </kt-form-group>
                            </kt-form-section>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ $t('btn.cancel') }}
                            </button>
                            <button type="submit" class="btn btn-primary" id="saveForbiddenKeywordBtn" :disabled="isSaving">
                                <i v-if="isSaving" class="fa fa-spinner fa-spin"></i>
                                {{ $t('btn.save') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import columns from '../../datatable/ForbiddenShebaColumn'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from '../../components/forbidden-keyword-actions-column'
import forbiddenKeywordFilter from '../../components/forbidden-sheba-filter'
import toastr from 'toastr'
import $ from 'jquery'
import axios from 'axios'

export default {
    components: {
        'forbidden-keyword-filter': forbiddenKeywordFilter,
    },
    data() {
        return {
            query: {},
            isEditMode: false,
            isSaving: false,
            formData: {
                id: null,
                name: '',
            },
            bankNickname: ''
        }
    },
    computed: {
        numberOnly: {
            get() {
                return this.formData.name.replace(/^IR/i, '')
            },
            set(value) {
                const cleanedValue = value.replace(/-/g, '').slice(0, 24);
                this.formData.name = 'IR' + cleanedValue;
            }
        },

        isStarshop() {
            return this.$route && this.$route.params && this.$route.params.slug === 'starshop'
        },

        apiPath() {
            return (path) => {
                return this.isStarshop ? ApiUrl.starshopPath(path) : ApiUrl.path(path)
            }
        },

        categorySlug() {
            return 'wallet-settlement-sheba-blacklist'
        },

        cleanHeaders() {
            const headers = {};
            if (AuthorizationHeader && typeof AuthorizationHeader === 'object') {
                Object.keys(AuthorizationHeader).forEach(key => {
                    const value = AuthorizationHeader[key];
                    if (value && typeof value === 'string' && value !== '[object Object]') {
                        headers[key] = value;
                    }
                });
            }
            return headers;
        },

        datatableProps() {
            return {
                id: "forbidden_keywords_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.apiPath(`admin/tags/category/${this.categorySlug}`),
                            method: 'GET',
                            headers: this.cleanHeaders,
                            params: this.query,
                            map: (res) => {
                                if (res && res.data && res.data.data) {
                                    return res.data.data.map(item => ({
                                        ...item,
                                        displayName: item.name.startsWith('IR') ? item.name : 'IR' + item.name
                                    }))
                                }
                                return []
                            }
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },

        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        onlyNumbers(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },

        reloadDatatable() {
            if (!this.$refs || !this.$refs.datatable) return
            const dt = this.$refs.datatable
            if (typeof dt.reload === 'function') return dt.reload()
            if (dt.KTDatatable && typeof dt.KTDatatable.reload === 'function') return dt.KTDatatable.reload()
        },

        filterAction(e, query) {
            this.query = { ...query }
            this.reloadDatatable()
        },

        openAddModal() {
            this.isEditMode = false
            this.resetForm()
            $('#forbiddenKeywordModal').modal('show')
        },

        openEditModal(keyword) {
            this.isEditMode = true
            this.formData = {
                id: keyword && keyword.id ? keyword.id : null,
                name: keyword && keyword.name ? keyword.name : '',
            }
            $('#forbiddenKeywordModal').modal('show')
        },

        resetForm() {
            this.formData = {
                id: null,
                name: 'IR',
            }
            this.bankNickname = ''
        },

        saveKeyword() {
            const form = $('#forbiddenKeywordForm')

            form.validate({
                rules: {
                    name: {
                        required: true,
                        minlength: 5
                    }
                }
            })

            if (!form.valid()) {
                return
            }

            if (!this.formData.name.startsWith('IR')) {
                this.formData.name = 'IR' + this.formData.name.replace(/^IR/i, '')
            }

            this.isSaving = true

            const requestData = this.isEditMode 
                ? this.formData
                : { 
                    name: this.formData.name,
                }

            const url = this.isEditMode
                ? this.apiPath(`admin/tags/${this.formData.id}`)
                : this.apiPath('admin/tags/create-sheba')

            const method = this.isEditMode ? 'PUT' : 'POST'

            axios({
                url: url,
                method: method,
                data: requestData,
                headers: this.cleanHeaders
            }).then(response => {
                if (response && response.data && response.data.message) {
                    this.toastr.success(response.data.message)
                }
                $('#forbiddenKeywordModal').modal('hide')
                this.reloadDatatable()
            }).catch(error => {
                const response = error && error.response
                if (response && response.data && response.data.errors) {
                    form.validate().showErrors(response.data.errors)
                }
                this.toastr.error(
                    response && response.data && response.data.message
                        ? response.data.message
                        : (this.$t && this.$t('forbidden_keywords.error_message'))
                )
            }).finally(() => {
                this.isSaving = false
            })
        },

        deleteKeyword(id) {
            const result = confirm(this.$t('label.wallet_settlement_blacklist.confirm_delete_sheba'))
            if (!result) return

            axios({
                url: this.apiPath(`admin/tags/${id}`),
                method: 'DELETE',
                headers: this.cleanHeaders
            }).then(response => {
                if (response && response.data && response.data.message) {
                    this.toastr.success(response.data.message)
                }
                this.reloadDatatable()
            }).catch(error => {
                const response = error && error.response
                this.toastr.error(
                    response && response.data && response.data.message
                        ? response.data.message
                        : (this.$t && this.$t('forbidden_keywords.delete_error'))
                )
            })
        }
    },

    watch: {
        '$route.params.slug': {
            handler: function (newSlug, oldSlug) {
                this.reloadDatatable()
            },
            immediate: false
        }
    },

    mounted() {
        window.editForbiddenKeyword = (keyword) => {
            this.openEditModal(keyword)
        }

        window.deleteForbiddenKeyword = (id) => {
            this.deleteKeyword(id)
        }
    },

    beforeDestroy() {
        if (typeof window !== 'undefined') {
            delete window.editForbiddenKeyword
            delete window.deleteForbiddenKeyword
        }
    }
}
</script>

<style scoped>
.modal-header .close {
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    font-size: 1.5rem;
    line-height: 1;
    color: #000;
    opacity: 0.5;
    cursor: pointer;
}

.modal-header .close:hover {
    opacity: 0.75;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.fa-spinner {
    margin-right: 5px;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

.float-left {
    float: left !important;
}

.input-group-text {
    background-color: #f8f9fa;
    border-color: #ced4da;
    font-weight: 500;
}

.text-info {
    margin-top: 5px;
    font-size: 0.875rem;
}

.ltr-input-group {
    direction: ltr !important;
}

.ltr-input-group .input-group-prepend {
    order: -1;
}

.ltr-input-group .form-control {
    text-align: left;
}
</style>